// extracted by mini-css-extract-plugin
export var bold = "_yo-0";